import { render, staticRenderFns } from "./TrainName.vue?vue&type=template&id=4b87ee1f&"
import script from "./TrainName.vue?vue&type=script&lang=js&"
export * from "./TrainName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports